import { Popover } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { IconCopyLink, IconGear, IconInfoRoom } from '../../../base/icons/svg';
import Button from '../../../base/ui/components/web/Button';
import ClickableIcon from '../../../base/ui/components/web/ClickableIcon';
import { BUTTON_TYPES } from '../../../base/ui/constants.any';
import { copyText } from '../../../base/util/copyText.web';
import { showSuccessNotification } from '../../../notifications/actions.web';
import { NOTIFICATION_TIMEOUT_TYPE } from '../../../notifications/constants';
import { openSettingsDialog } from '../../../settings/actions.web';
import ItemInfoRoom from './ItemInfoRoom';
const useStyles = makeStyles()(theme => {
    return {
        infoRoomPopover: {
            '& .MuiPaper-root': {
                backgroundColor: '#292929',
                display: 'flex',
                flexDirection: 'column',
                color: 'white'
            }
        },
        headerInfo: {
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '24px',
            color: 'white',
            padding: '16px 24px 8px 24px',
            maxWidth: '500px'
        },
        footerInfo: {
            borderTop: `1px solid ${theme.palette.default00}`,
            padding: '8px 24px 1px 24px',
        }
    };
});
const InfoRoom = () => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const [securityRoom, setSecurityRoom] = useState('');
    const { roomInfo, password } = useSelector((state) => state['features/base/conference']);
    const { isLocked } = useSelector((state) => state['features/lock-room']);
    const { lobbyEnabled } = useSelector((state) => state['features/lobby']);
    const handleClick = (event) => {
        setAnchorEl(event?.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleCopyUrl = async (url) => {
        await copyText(url);
        dispatch(showSuccessNotification({
            titleKey: 'prejoin.linkCopied'
        }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
    };
    const handleOpenSettingsDialog = () => {
        handleClose();
        setTimeout(() => {
            dispatch(openSettingsDialog());
        }, 250);
    };
    /**
     * Lấý thông tin chủ phòng
     * @returns
     */
    const getRoomOwner = () => {
        if (roomInfo?.participant.length) {
            const owner = roomInfo?.participant.find((p) => p.role === "owner");
            return owner?.name || "";
        }
        return "";
    };
    /**
     * Lấy thông tin bảo mật của phòng
     * @returns
     */
    const getSecurityRoom = () => {
        let securityRoomArray = [];
        if (password || roomInfo?.password)
            securityRoomArray.push(t("infoRoom.password"));
        if (lobbyEnabled)
            securityRoomArray.push(t("infoRoom.lobby"));
        if (isLocked)
            securityRoomArray.push(t("infoRoom.locked"));
        return securityRoomArray.join(", ");
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const DATA_ITEMS = [
        {
            label: t('infoRoom.owner'),
            content: roomInfo?.creator || getRoomOwner()
        },
        {
            label: t('infoRoom.desc'),
            content: roomInfo?.description
        },
        {
            label: t('infoRoom.link'),
            content: roomInfo?.link,
            contentText: roomInfo?.link
        },
        {
            label: '',
            content: React.createElement(Button, { size: 'tiny', label: t('infoRoom.copyLink'), icon: IconCopyLink, type: BUTTON_TYPES.TERTIARY, onClick: () => handleCopyUrl(roomInfo?.link) })
        },
        {
            label: t('infoRoom.roomId'),
            content: roomInfo?.roomId
        },
        {
            label: t('infoRoom.password'),
            content: password
        },
        {
            label: t('infoRoom.security'),
            content: securityRoom
        },
        {
            label: t('infoRoom.meetingMode'),
            content: roomInfo?.meeting_mode === 1 ? t('infoRoom.meetingPrivate') : t('infoRoom.meetingPublic')
        }
    ];
    useEffect(() => {
        setSecurityRoom((prev) => getSecurityRoom());
    }, [lobbyEnabled, password, roomInfo?.password, isLocked, i18n.language]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ClickableIcon, { "aria-describedby": id, accessibilityLabel: 'info-room', icon: IconInfoRoom, onClick: (e) => handleClick(e) }),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, className: classes.infoRoomPopover },
            React.createElement("h1", { className: classes.headerInfo }, roomInfo?.roomName),
            DATA_ITEMS.map((item, index) => (React.createElement(ItemInfoRoom, { key: index, label: item.label, content: item.content, contentText: item.contentText }))),
            React.createElement("div", { className: classes.footerInfo },
                React.createElement(Button, { type: BUTTON_TYPES.TERTIARY, label: t('infoRoom.settingRoom'), icon: IconGear, onClick: handleOpenSettingsDialog })))));
};
export default InfoRoom;
